// extracted by mini-css-extract-plugin
module.exports = {"cls1":"SideNav-OverflowWrapper-module--cls1--1j5lb","cls2":"SideNav-OverflowWrapper-module--cls2--2_4Kd SideNav-OverflowWrapper-module--cls1--1j5lb"};